import { BrokeNotificationData } from '@/modules/client-setting/type'
import { DataTable } from '@/common/ui/table/data-table'
import { columns, writeAccessorKeys } from './constants'
import useHasPermission from '@/common/hooks/useHasPermission'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useMemo } from 'react'

interface BrokeNotificationTableProps {
	data: BrokeNotificationData[]
	isLoading?: boolean
}

export default function BrokeNotificationTable({
	data,
	isLoading,
}: BrokeNotificationTableProps) {
	const hasWritePermission = useHasPermission(PermissionKeys.WEB_SETTING)

	const filteredColumns = useMemo(
		() =>
			columns.filter(
				(column) =>
					hasWritePermission ||
					('accessorKey' in column &&
						!writeAccessorKeys.includes(column.accessorKey)),
			),
		[hasWritePermission],
	)

	return (
		<div className="space-y-4">
			<DataTable columns={filteredColumns} data={data} isLoading={isLoading} />
		</div>
	)
}
